function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "583px",
    height: "220px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff7c66",
    d: "M 545.5,3.5 C 555.839,3.33351 566.172,3.50017 576.5,4C 577,4.5 577.5,5 578,5.5C 578.667,13.8333 578.667,22.1667 578,30.5C 577.25,31.1258 576.416,31.6258 575.5,32C 565.453,32.8082 555.453,32.6415 545.5,31.5C 544.808,30.9747 544.308,30.3081 544,29.5C 543.333,21.5 543.333,13.5 544,5.5C 544.717,4.9558 545.217,4.28913 545.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#080808",
    d: "M 127.5,29.5 C 127.427,31.0269 128.094,32.0269 129.5,32.5C 131.9,34.2964 133.567,36.6298 134.5,39.5C 134.427,41.0269 135.094,42.0269 136.5,42.5C 139.872,47.9481 141.872,53.9481 142.5,60.5C 130.345,61.4952 118.011,61.8286 105.5,61.5C 95.9176,40.0621 80.251,34.2288 58.5,44C 47.5089,53.15 41.6756,64.9833 41,79.5C 39.4913,94.1093 41.658,108.109 47.5,121.5C 47.427,123.027 48.0937,124.027 49.5,124.5C 60.8055,136.91 74.4721,140.41 90.5,135C 94.5423,132.984 98.209,130.484 101.5,127.5C 102.906,127.027 103.573,126.027 103.5,124.5C 105.763,119.71 107.43,114.71 108.5,109.5C 99.3483,108.506 90.015,108.173 80.5,108.5C 80.5,99.8333 80.5,91.1667 80.5,82.5C 101.167,82.5 121.833,82.5 142.5,82.5C 142.5,109.5 142.5,136.5 142.5,163.5C 134.167,163.5 125.833,163.5 117.5,163.5C 117.276,159.821 116.942,156.154 116.5,152.5C 116.785,150.712 116.452,149.045 115.5,147.5C 114.893,147.624 114.56,147.957 114.5,148.5C 106.334,159.453 95.3343,165.62 81.5,167C 65.287,168.954 50.287,165.787 36.5,157.5C 36.0269,156.094 35.0269,155.427 33.5,155.5C 33.0269,154.094 32.0269,153.427 30.5,153.5C 29.5,153.167 28.8333,152.5 28.5,151.5C 27.0892,149.086 25.0892,147.419 22.5,146.5C 13.1872,135.535 7.35384,122.868 5,108.5C 3.55706,97.8691 3.22372,87.2024 4,76.5C 4.4865,70.8889 5.65316,65.5556 7.5,60.5C 8.92381,58.4855 9.59047,56.1522 9.5,53.5C 10.4654,48.9024 12.4654,44.9024 15.5,41.5C 16.9063,41.0269 17.573,40.0269 17.5,38.5C 19.016,35.4669 21.016,32.8003 23.5,30.5C 26.4274,29.2427 28.7607,27.2427 30.5,24.5C 36.4613,19.0177 43.4613,15.351 51.5,13.5C 54.1522,13.5905 56.4855,12.9238 58.5,11.5C 78.8882,7.0079 98.2215,9.84123 116.5,20C 120.612,22.7118 124.278,25.8784 127.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.929
    },
    fill: "#646464",
    d: "M 58.5,11.5 C 56.4855,12.9238 54.1522,13.5905 51.5,13.5C 53.5145,12.0762 55.8478,11.4095 58.5,11.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#5d5d5d",
    d: "M 30.5,24.5 C 28.7607,27.2427 26.4274,29.2427 23.5,30.5C 25.2393,27.7573 27.5726,25.7573 30.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.69
    },
    fill: "#979797",
    d: "M 127.5,29.5 C 128.906,29.9731 129.573,30.9731 129.5,32.5C 128.094,32.0269 127.427,31.0269 127.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#787878",
    d: "M 17.5,38.5 C 17.573,40.0269 16.9063,41.0269 15.5,41.5C 15.427,39.9731 16.0937,38.9731 17.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#a0a0a0",
    d: "M 134.5,39.5 C 135.906,39.9731 136.573,40.9731 136.5,42.5C 135.094,42.0269 134.427,41.0269 134.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0b0b0b",
    d: "M 384.5,54.5 C 384.427,56.0269 385.094,57.0269 386.5,57.5C 388.262,58.2623 389.262,59.5956 389.5,61.5C 389.427,63.0269 390.094,64.0269 391.5,64.5C 394.55,70.0116 396.384,76.0116 397,82.5C 397.333,105.167 397.667,127.833 398,150.5C 398.325,154.616 399.159,158.616 400.5,162.5C 388.518,163.499 376.518,163.832 364.5,163.5C 363.793,160.214 363.46,156.881 363.5,153.5C 363.762,152.022 363.429,150.689 362.5,149.5C 361.702,149.957 361.369,150.624 361.5,151.5C 349.666,164.28 335,169.447 317.5,167C 290.063,160.97 280.563,144.47 289,117.5C 290.371,114.734 292.204,112.401 294.5,110.5C 296.167,109.5 297.5,108.167 298.5,106.5C 304.038,101.064 310.705,97.7308 318.5,96.5C 321.152,96.5905 323.485,95.9238 325.5,94.5C 337.529,91.6626 349.862,90.3293 362.5,90.5C 363.344,77.1829 357.177,69.8495 344,68.5C 333.685,68.8727 327.185,73.8727 324.5,83.5C 313.5,83.5 302.5,83.5 291.5,83.5C 291.5,81.8333 291.5,80.1667 291.5,78.5C 292.924,76.4855 293.59,74.1522 293.5,71.5C 295.008,65.8048 298.008,61.1381 302.5,57.5C 303.833,56.8333 304.833,55.8333 305.5,54.5C 310.049,49.3875 315.716,46.0542 322.5,44.5C 325.152,44.5905 327.485,43.9238 329.5,42.5C 345.703,38.6658 361.369,40.4991 376.5,48C 379.355,50.0308 382.022,52.1975 384.5,54.5 Z M 349.5,111.5 C 353.833,111.5 358.167,111.5 362.5,111.5C 362.5,114.167 362.5,116.833 362.5,119.5C 362.5,119.833 362.5,120.167 362.5,120.5C 361.262,122.214 360.595,124.214 360.5,126.5C 357.93,131.738 354.264,136.072 349.5,139.5C 347.973,139.427 346.973,140.094 346.5,141.5C 339.342,144.292 332.342,143.959 325.5,140.5C 324.5,138.833 323.167,137.5 321.5,136.5C 319.468,124 324.801,116.5 337.5,114C 341.534,113.117 345.534,112.284 349.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070707",
    d: "M 518.5,52.5 C 518.427,54.0269 519.094,55.0269 520.5,55.5C 523.393,57.7485 525.06,60.7485 525.5,64.5C 525.41,67.1522 526.076,69.4855 527.5,71.5C 528.319,74.3054 528.819,77.3054 529,80.5C 529.5,108.165 529.667,135.831 529.5,163.5C 517.833,163.5 506.167,163.5 494.5,163.5C 494.667,137.498 494.5,111.498 494,85.5C 493.56,83.1341 493.06,80.8008 492.5,78.5C 492.715,76.8212 492.048,75.8212 490.5,75.5C 486.85,70.9263 482.017,68.5929 476,68.5C 462.087,71.9456 455.087,80.9456 455,95.5C 454.5,118.164 454.333,140.831 454.5,163.5C 443.5,163.5 432.5,163.5 421.5,163.5C 421.5,124.167 421.5,84.8333 421.5,45.5C 432.5,45.5 443.5,45.5 454.5,45.5C 454.334,49.8461 454.501,54.1794 455,58.5C 466.694,42.6902 482.194,37.1902 501.5,42C 508.507,43.4953 514.174,46.9953 518.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#555555",
    d: "M 329.5,42.5 C 327.485,43.9238 325.152,44.5905 322.5,44.5C 324.515,43.0762 326.848,42.4095 329.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#4a4a4a",
    d: "M 191.5,46.5 C 185.411,45.8531 179.244,45.5197 173,45.5C 166.793,45.5042 160.96,46.1709 155.5,47.5C 154.596,46.791 154.263,45.791 154.5,44.5C 167.212,43.8536 179.545,44.5203 191.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.749
    },
    fill: "#4d4d4d",
    d: "M 277.5,48.5 C 277.5,47.5 277.5,46.5 277.5,45.5C 266.086,45.1894 254.752,45.5227 243.5,46.5C 249.128,45.1707 255.128,44.504 261.5,44.5C 267.5,44.6667 273.5,44.8333 279.5,45C 278.915,46.3024 278.249,47.469 277.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.11
    },
    fill: "#e1e1e1",
    d: "M 544.5,43.5 C 544.5,43.8333 544.5,44.1667 544.5,44.5C 544.5,83.5 544.5,122.5 544.5,161.5C 555.5,161.5 566.5,161.5 577.5,161.5C 577.833,161.5 578.167,161.5 578.5,161.5C 567.012,162.495 555.345,162.828 543.5,162.5C 543.168,122.663 543.501,82.9965 544.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 544.5,44.5 C 555.5,44.5 566.5,44.5 577.5,44.5C 577.5,83.5 577.5,122.5 577.5,161.5C 566.5,161.5 555.5,161.5 544.5,161.5C 544.5,122.5 544.5,83.5 544.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.275
    },
    fill: "#afafaf",
    d: "M 544.5,44.5 C 544.5,44.1667 544.5,43.8333 544.5,43.5C 555.833,43.5 567.167,43.5 578.5,43.5C 578.5,82.8333 578.5,122.167 578.5,161.5C 578.167,161.5 577.833,161.5 577.5,161.5C 577.5,122.5 577.5,83.5 577.5,44.5C 566.5,44.5 555.5,44.5 544.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0c0c",
    d: "M 191.5,46.5 C 191.12,48.698 191.787,50.3646 193.5,51.5C 202.565,74.0295 210.232,97.0295 216.5,120.5C 216.231,122.429 216.731,124.095 218,125.5C 218.483,124.552 218.649,123.552 218.5,122.5C 219.924,120.485 220.59,118.152 220.5,115.5C 220.7,112.37 221.366,109.37 222.5,106.5C 224.213,105.365 224.88,103.698 224.5,101.5C 227.971,90.4214 231.637,79.4214 235.5,68.5C 237.213,67.3646 237.88,65.698 237.5,63.5C 239.129,57.6075 241.129,51.9409 243.5,46.5C 254.752,45.5227 266.086,45.1894 277.5,45.5C 277.5,46.5 277.5,47.5 277.5,48.5C 260.624,92.5903 243.457,136.59 226,180.5C 221.523,192.966 214.023,203.133 203.5,211C 191.583,216.932 179.249,217.932 166.5,214C 164.544,205.099 163.878,195.932 164.5,186.5C 177.842,188.91 187.676,184.243 194,172.5C 196.114,167.94 197.947,163.274 199.5,158.5C 184.828,121.482 170.162,84.4818 155.5,47.5C 160.96,46.1709 166.793,45.5042 173,45.5C 179.244,45.5197 185.411,45.8531 191.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.765
    },
    fill: "#3c3c3c",
    d: "M 454.5,45.5 C 443.5,45.5 432.5,45.5 421.5,45.5C 421.5,84.8333 421.5,124.167 421.5,163.5C 420.501,124.004 420.168,84.3368 420.5,44.5C 432.012,44.1719 443.346,44.5052 454.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#767676",
    d: "M 191.5,46.5 C 192.537,47.9303 193.204,49.597 193.5,51.5C 191.787,50.3646 191.12,48.698 191.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#767676",
    d: "M 518.5,52.5 C 519.906,52.9731 520.573,53.9731 520.5,55.5C 519.094,55.0269 518.427,54.0269 518.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.639
    },
    fill: "#9c9c9c",
    d: "M 384.5,54.5 C 385.906,54.9731 386.573,55.9731 386.5,57.5C 385.094,57.0269 384.427,56.0269 384.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#6c6c6c",
    d: "M 9.5,53.5 C 9.59047,56.1522 8.92381,58.4855 7.5,60.5C 7.40953,57.8478 8.07619,55.5145 9.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.592
    },
    fill: "#8f8f8f",
    d: "M 305.5,54.5 C 304.833,55.8333 303.833,56.8333 302.5,57.5C 302.5,55.5 303.5,54.5 305.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#f8f8f8",
    d: "M 142.5,60.5 C 143.043,60.56 143.376,60.8933 143.5,61.5C 130.673,62.825 118.006,62.825 105.5,61.5C 118.011,61.8286 130.345,61.4952 142.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.392
    },
    fill: "#999999",
    d: "M 389.5,61.5 C 390.906,61.9731 391.573,62.9731 391.5,64.5C 390.094,64.0269 389.427,63.0269 389.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.902
    },
    fill: "#7f7f7f",
    d: "M 237.5,63.5 C 237.88,65.698 237.213,67.3646 235.5,68.5C 235.796,66.597 236.463,64.9303 237.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.765
    },
    fill: "#646464",
    d: "M 525.5,64.5 C 526.924,66.5145 527.59,68.8478 527.5,71.5C 526.076,69.4855 525.41,67.1522 525.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#6f6f6f",
    d: "M 293.5,71.5 C 293.59,74.1522 292.924,76.4855 291.5,78.5C 291.41,75.8478 292.076,73.5145 293.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.91
    },
    fill: "#848484",
    d: "M 490.5,75.5 C 492.048,75.8212 492.715,76.8212 492.5,78.5C 491.599,77.7095 490.932,76.7095 490.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.184
    },
    fill: "#c3c3c3",
    d: "M 142.5,163.5 C 142.5,136.5 142.5,109.5 142.5,82.5C 121.833,82.5 101.167,82.5 80.5,82.5C 80.5,91.1667 80.5,99.8333 80.5,108.5C 90.015,108.173 99.3483,108.506 108.5,109.5C 98.8333,109.5 89.1667,109.5 79.5,109.5C 79.5,100.167 79.5,90.8333 79.5,81.5C 100.833,81.5 122.167,81.5 143.5,81.5C 143.831,109.005 143.498,136.338 142.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.545
    },
    fill: "#767676",
    d: "M 291.5,78.5 C 291.5,80.1667 291.5,81.8333 291.5,83.5C 302.5,83.5 313.5,83.5 324.5,83.5C 313.346,84.4948 302.012,84.8281 290.5,84.5C 290.205,82.2646 290.539,80.2646 291.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.953
    },
    fill: "#5b5b5b",
    d: "M 325.5,94.5 C 323.485,95.9238 321.152,96.5905 318.5,96.5C 320.515,95.0762 322.848,94.4095 325.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#797979",
    d: "M 224.5,101.5 C 224.88,103.698 224.213,105.365 222.5,106.5C 222.796,104.597 223.463,102.93 224.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.616
    },
    fill: "#949494",
    d: "M 298.5,106.5 C 297.5,108.167 296.167,109.5 294.5,110.5C 294.833,108.167 296.167,106.833 298.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53
    },
    fill: "#828282",
    d: "M 349.5,111.5 C 353.97,110.514 358.637,110.181 363.5,110.5C 363.81,113.713 363.477,116.713 362.5,119.5C 362.5,116.833 362.5,114.167 362.5,111.5C 358.167,111.5 353.833,111.5 349.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.753
    },
    fill: "#6f6f6f",
    d: "M 220.5,115.5 C 220.59,118.152 219.924,120.485 218.5,122.5C 218.41,119.848 219.076,117.515 220.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58
    },
    fill: "#7e7e7e",
    d: "M 47.5,121.5 C 48.9063,121.973 49.573,122.973 49.5,124.5C 48.0937,124.027 47.427,123.027 47.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#818181",
    d: "M 216.5,120.5 C 217.167,121.167 217.833,121.833 218.5,122.5C 218.649,123.552 218.483,124.552 218,125.5C 216.731,124.095 216.231,122.429 216.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.91
    },
    fill: "#787878",
    d: "M 362.5,120.5 C 362.741,122.898 362.074,124.898 360.5,126.5C 360.595,124.214 361.262,122.214 362.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.451
    },
    fill: "#9d9d9d",
    d: "M 103.5,124.5 C 103.573,126.027 102.906,127.027 101.5,127.5C 101.427,125.973 102.094,124.973 103.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.871
    },
    fill: "#838383",
    d: "M 321.5,136.5 C 323.167,137.5 324.5,138.833 325.5,140.5C 323.167,140.167 321.833,138.833 321.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#7d7d7d",
    d: "M 349.5,139.5 C 349.027,140.906 348.027,141.573 346.5,141.5C 346.973,140.094 347.973,139.427 349.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.627
    },
    fill: "#a5a5a5",
    d: "M 22.5,146.5 C 25.0892,147.419 27.0892,149.086 28.5,151.5C 25.9108,150.581 23.9108,148.914 22.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.169
    },
    fill: "#b1b1b1",
    d: "M 114.5,148.5 C 114.56,147.957 114.893,147.624 115.5,147.5C 116.452,149.045 116.785,150.712 116.5,152.5C 115.833,151.167 115.167,149.833 114.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.18
    },
    fill: "#d1d1d1",
    d: "M 363.5,153.5 C 362.833,152.833 362.167,152.167 361.5,151.5C 361.369,150.624 361.702,149.957 362.5,149.5C 363.429,150.689 363.762,152.022 363.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.518
    },
    fill: "#959595",
    d: "M 30.5,153.5 C 32.0269,153.427 33.0269,154.094 33.5,155.5C 31.9731,155.573 30.9731,154.906 30.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42
    },
    fill: "#9a9a9a",
    d: "M 33.5,155.5 C 35.0269,155.427 36.0269,156.094 36.5,157.5C 34.9731,157.573 33.9731,156.906 33.5,155.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogo);
export default __webpack_public_path__ + "static/media/fullLogo.72973ac15c6d3db5b6ced61a580c5f2d.svg";
export { ForwardRef as ReactComponent };